import React, { Component } from 'react';
import { connect } from 'react-redux';
import Avatar from '../../assets/dashboard/avatar.svg';
import SettingsNavBar from './SettingsNavBar';
import SideBar from '../../components/SideBar';
import { updateUser, clearUserStatuses } from '../../actions';

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: this.props.firstName,
      lastName: this.props.lastName,
      email: this.props.email,
    };
  }

  componentDidMount() {
    this.props.clearUserStatuses();
  }

  componentWillUnmount() {
    this.props.clearUserStatuses();
  }

  handleChange = (event) => {
    this.props.clearUserStatuses();
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    this.setState((prevState) => {
      return {
        firstNameError: !prevState.firstName,
        lastNameError: !prevState.lastName,
        emailError: !prevState.email || !(/\S+@\S+\.\S+/.test(prevState.email)),
      };
    }, () => {
      if (
        !this.state.firstNameError
        && !this.state.lastNameError
        && !this.state.emailError
      ) {
        this.props.updateUser(this.props.userid, {
          email: this.state.email,
          first_name: this.state.firstName,
          last_name: this.state.lastName,
        });
      }
    });
  }

  render() {
    return (
      <div className="flex-container">
        <SideBar defaultPage="account" />
        <SettingsNavBar defaultPage="profile" />
        <div className="profile-container">
          <h2 className="color account-header">Edit Profile</h2>
          <div className="profile-body-container">
            <img src={Avatar} alt="profile-icon" />
            <div className="box profile-form-container">
              <div className="form-row-container">
                <label className="short-label" htmlFor="firstName">
                  First Name
                  {this.state.firstNameError ? <p>This field cannot be left blank</p> : null}
                  <input type="text" name="firstName" value={this.state.firstName} onChange={this.handleChange} />
                </label>
                <label className="short-label" htmlFor="firstName">
                  Last Name
                  {this.state.lastNameError ? <p>This field cannot be left blank</p> : null}
                  <input type="text" name="lastName" value={this.state.lastName} onChange={this.handleChange} />
                </label>
              </div>
              <div className="form-row-container">
                <label className="long-label" htmlFor="firstName">
                  Email
                  {this.state.emailError ? <p>This email is not valid</p> : null}
                  <input type="text" name="email" value={this.state.email} onChange={this.handleChange} />
                </label>
              </div>
              {this.props.updateError ? <p className="settings-error-text">There was an error updating your profile</p> : null}
              {this.props.successMsg ? <p className="settings-success-text">Your profile has been successfully updated</p> : null}
              <button onClick={this.handleSubmit} className="save-button" type="button">Save</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    userid: state.user.userid,
    lastName: state.user.lastName,
    firstName: state.user.firstName,
    email: state.user.email,
    updateError: state.user.updateError,
    successMsg: state.user.updateSuccess,
  }
);

export default connect(mapStateToProps, { updateUser, clearUserStatuses })(Profile);
